import { render } from "./VotersDesignation.vue?vue&type=template&id=a5a9fcc6"
import script from "./VotersDesignation.vue?vue&type=script&lang=js"
export * from "./VotersDesignation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__